export enum INFO_MESSAGE_TYPE {
  success = 'success',
  warning = 'warning',
  info = 'info',
}

export type CalloutType = 'success' | 'warning' | 'info' | 'danger' | 'highlight';

/**
 * We want to handle default callout type in a special way
 * inside our Callout component. In order to do that we need
 * to assign a special type to Callout when its size is compact
 * and variant is not provided.
 */
export type EnhancedCalloutType = CalloutType | 'compactDefault';

export type CalloutSize = 'compact' | 'regular';
